(ns rothko.editor.word.transform
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.navigator :refer [selectionnav]]
            [rothko.editor.document.navigators :as n]))

(defn mark-as-edited
  "Returns a path which will mark tokens as edited."
  ([index]
   (mark-as-edited index index))
  ([start-index end-index]
   [:script
    (sp/srange start-index (inc end-index))
    sp/ALL
    (sp/terminal
     (fn [& args]
       (assoc (last args) :edited? true)))]))

(def remove-edited?-marking
  (sp/with-fresh-collected
    [(sp/collect-one :selection)
     (selectionnav
      []
      (transform*
       [_ {:keys [start-index end-index] :as selection} structure next-fn]
       (sp/transform
        [:script
         (sp/srange start-index (inc end-index))
         sp/ALL
         (sp/terminal
          (fn [& args]
            (dissoc (last args) :edited?)))]
        next-fn
        structure)))]))
